import {
  CitiesResponseSchema,
  DealerContactResponseSchema,
  type CitiesResponse,
  type DealerChannel,
  type DealerContactResponse,
} from '../contracts/handles';
import type { RequestFn } from './client';

/**
 * Namespace `client.dealers` — данные дилеров, общие для блоков «найти в
 * магазинах» (ADR-0060 Фаза 5; ADR-0083 контакт-редирект).
 *  - `cities()` — список городов для пикера (distinct из `dealers`, канон-порядок).
 *    НЕ sensitive: список городов не ПДн, JWT не требует.
 *  - `contact(...)` — резолв-эндпоинт контакта (ADR-0083 §3.2, Amendment): по
 *    `(dealerId, channel, i)` отдаёт целевой deeplink `{ url }` (WA/TG/call) или
 *    номер `{ number }` (MAX, оверлей-поиск). Soft-gate 401 без JWT → `auth: true`.
 */
export interface DealersApi {
  /** GET /api/dealers/cities — города дилеров для пикера (канон-порядок). */
  cities(): Promise<CitiesResponse>;
  /**
   * GET /api/dealers/:dealerId/contact?channel&i[&text] — резолв контакта
   * (ADR-0083 Amendment). Авторизованный fetch (header-bearer) — `openExternal`
   * заголовок не несёт, поэтому 302-навигация в приложении не годится; эндпоинт
   * отдаёт JSON, клиент сам зовёт `openExternal`. `text` (prefill сообщение) —
   * только для `whatsapp`. Возвращает `{ url }` (WA/TG/call) либо `{ number }` (MAX).
   */
  contact(
    dealerId: string,
    channel: DealerChannel,
    i: number,
    text?: string,
  ): Promise<DealerContactResponse>;
}

export function createDealersApi(request: RequestFn): DealersApi {
  return {
    cities: () =>
      request({
        method: 'GET',
        path: '/api/dealers/cities',
        responseSchema: CitiesResponseSchema,
      }),
    contact: (dealerId, channel, i, text) =>
      request({
        method: 'GET',
        path: `/api/dealers/${encodeURIComponent(dealerId)}/contact`,
        // text шлём только для whatsapp (prefill); для прочих каналов undefined →
        // buildUrl его пропускает.
        query: { channel, i, text: channel === 'whatsapp' ? text : undefined },
        responseSchema: DealerContactResponseSchema,
        auth: true,
      }),
  };
}
